//React
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";

//Libs
import { Button, Icon } from "semantic-ui-react";
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../../services/apis";
import { systemLogs } from "../../../../../services/system_logs";
import { useRouter } from "../../../../../hooks/router";

//Components
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loader from "../../../../../components/Loader";
import Loading from "../../../../../components/Loading";

import * as yup from "yup";

//Styles
import {
  Container,
  QuestaoContainer,
  OpcaoContainer,
  SaveContainer,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  SemanticTable,
} from "./styles";
import TextEditor from "../../../../../components/Admin/StatefulTextEditor";
import { generateJSID } from "../../../../../utils/Utils";
import AnswerFileUpload from "../components/AnswerFileUpload";

const CriarTeste = () => {
  const [titulo, setTitulo] = useState("");
  const [questoes, setQuestoes] = useState([]);
  const [idLicao, setIdLicao] = useState(null);
  const [answerFile, setAnswerFile] = useState(null);

  const router = useRouter();

  useEffect(() => {
    const { id_licao } = router.query;

    setIdLicao(id_licao);
  }, [router]);

  const handleTitulo = useCallback((e) => {
    const { value } = e.target;
    setTitulo(value);
  });

  const handlePergunta = useCallback(
    (value, index) => {
      const newQuestoes = [...questoes];

      newQuestoes[index].pergunta = value;

      setQuestoes(newQuestoes);
    },
    [questoes]
  );

  const handleIsAberta = useCallback(
    (index) => {
      const newQuestoes = [...questoes];

      newQuestoes[index].isAberta = !newQuestoes[index].isAberta;
      newQuestoes[index].opcoes = newQuestoes[index].opcoes || [];

      setQuestoes(newQuestoes);
    },
    [questoes]
  );

  const handleOpcaoTexto = useCallback(
    (value, questaoIndex, opcaoIndex) => {
      const newQuestoes = [...questoes];

      newQuestoes[questaoIndex].opcoes[opcaoIndex].texto = value;

      setQuestoes(newQuestoes);
    },
    [questoes]
  );

  const handleOpcaoIsAnswer = useCallback(
    (questaoIndex, opcaoIndex) => {
      const newQuestoes = [...questoes];
      const newOpcoes = [...newQuestoes[questaoIndex].opcoes];

      newQuestoes[questaoIndex].opcoes = newOpcoes.map((opcao, index) => ({
        ...opcao,
        isAnswer: index === opcaoIndex,
      }));

      setQuestoes(newQuestoes);
    },
    [questoes]
  );

  const removeOpcao = useCallback(
    (questaoIndex, opcaoIndex) => {
      const newQuestoes = [...questoes];
      const newOpcoes = [...newQuestoes[questaoIndex].opcoes];

      const [deletedOpcao] = newOpcoes.splice(opcaoIndex, 1);

      newQuestoes[questaoIndex].opcoes = newOpcoes;

      if (deletedOpcao.isAnswer && newQuestoes[questaoIndex].opcoes.length) {
        newQuestoes[questaoIndex].opcoes[0].isAnswer = true;
      }

      setQuestoes(newQuestoes);
    },
    [questoes]
  );

  const addOpcao = useCallback(
    (index) => {
      const newQuestoes = [...questoes];
      const defaultOpcao = {
        texto: "",
        isAnswer: newQuestoes[index].opcoes.length === 0,
      };

      newQuestoes[index].opcoes.push(defaultOpcao);

      setQuestoes(newQuestoes);
    },
    [questoes]
  );

  const addQuestao = () => {
    const defaultQuestao = {
      id: generateJSID(),
      pergunta: "",
      opcoes: [{ texto: "", isAnswer: true }],
    };

    setQuestoes((questoes) => [...questoes, defaultQuestao]);
  };

  const removeQuestao = useCallback(
    (questaoIndex) => {
      const newQuestoes = [...questoes];

      newQuestoes.splice(questaoIndex, 1);

      setQuestoes(newQuestoes);
    },
    [questoes]
  );

  const saveTeste = useCallback(
    async (associateLicao) => {
      try {
        const { id_licao } = router.query;

        const formatedQuestoes = questoes.map((questao) => {
          const cloneQuestao = { ...questao };
          const opcoes = !cloneQuestao.isAberta ? cloneQuestao.opcoes : null;

          delete cloneQuestao.isAberta;

          return { ...cloneQuestao, opcoes };
        });

        let payload = {
          titulo,
          json: {
            titulo,
            questoes: formatedQuestoes,
          },
        };

        const yupTemplate = await yup.object().shape({
          titulo: yup
            .string("Necessário que informe o título do teste")
            .required("Necessário que informe o título do teste"),
          json: yup
            .object()
            .shape({
              titulo: yup
                .string("Necessário que informe o título do teste")
                .required("Necessário que informe o título do teste"),
              questoes: yup
                .array()
                .of(
                  yup.object().shape({
                    id: yup
                      .string("Erro na geração pergunta")
                      .required("Erro na geração da pergunta"),
                    pergunta: yup.string(
                      "Necessário que a pergunta tenha um enunciado"
                    ),
                    // opcoes: yup.array().of(
                    //   yup.object().shape({
                    //     texto: yup
                    //       .string("Pergunta sem enunciado")
                    //       .required("Pergunta sem enunciado"),
                    //     isAnswer: yup
                    //       .boolean("Valor precisa ser booleano")
                    //       .required("Valor precisa ser booleano"),
                    //   })
                    // ),
                  })
                )
                .min(1, "Precisa ter pelo menos uma questão"),
            })
            .required("Teste inválido"),
        });

        const isCorrect = await yupTemplate
          .validate(payload, { abortEarly: true })
          .then((res) => true)
          .catch(async (err) => {
            return new Promise((resolve, reject) =>
              swal({
                // "Erro!", `${err}`, "error"
                title: "Erro",
                text: `${err}`,
                icon: "error",
                button: "Salvar mesmo assim",
              }).then((res) => {
                if (res) {
                  resolve(true);
                }

                reject(false);
              })
            );
          });

        if (!isCorrect) {
          return;
        }

        const params = {};

        if (associateLicao) {
          params.id_licao = id_licao;
        }

        if (answerFile) {
          const answerFileFormData = new FormData();

          answerFileFormData.append("file", answerFile);
          answerFileFormData.append("path", "anexos");
          answerFileFormData.append("categorize", "yes");

          const response = await api.post("/upload", answerFileFormData);

          payload = {
            ...payload,
            answer_file_url: response.data.url,
          };
        }

        await api.post("testes/create", payload, { params });

        swal("Teste salvo !", "Este teste foi salvo com sucesso !", "success");
      } catch (err) {
        console.error(err);
      }
    },
    [titulo, questoes, router, answerFile]
  );

  const handleChangeAnswerFile = (file) => {
    setAnswerFile(file);
  };

  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Criar Teste</Title>

        <Input
          placeholder="Titulo do Teste"
          value={titulo}
          onChange={handleTitulo}
        />

        <h2>Questões</h2>

        {questoes.map((questao, questaoIndex) => (
          <QuestaoContainer>
            Pergunta:
            <div>
              <Button negative icon onClick={() => removeQuestao(questaoIndex)}>
                Remover questão
              </Button>
            </div>
            <OpcaoContainer>
              <OpcaoContainer>
                <input
                  type="radio"
                  checked={!questao.isAberta}
                  onClick={() => {
                    handleIsAberta(questaoIndex);
                  }}
                />

                <label>Questao Fechada ?</label>
              </OpcaoContainer>
              <OpcaoContainer>
                <input
                  type="radio"
                  checked={questao.isAberta}
                  onClick={() => {
                    handleIsAberta(questaoIndex);
                  }}
                />

                <label>Questao Aberta ?</label>
              </OpcaoContainer>
            </OpcaoContainer>
            <TextEditor
              default={questao.pergunta}
              handleChange={(value) => handlePergunta(value, questaoIndex)}
            />
            {!questao.isAberta && (
              <>
                {questao.opcoes.map((opcao, opcaoIndex) => (
                  <OpcaoContainer>
                    <input
                      type="radio"
                      checked={opcao.isAnswer}
                      onClick={(texto) =>
                        handleOpcaoIsAnswer(questaoIndex, opcaoIndex)
                      }
                    />
                    <Input
                      placeholder="Enunciado da Questão"
                      value={opcao.texto}
                      onChange={(e) =>
                        handleOpcaoTexto(
                          e.target.value,
                          questaoIndex,
                          opcaoIndex
                        )
                      }
                    />
                    <Button
                      title="Remover opção"
                      negative
                      icon
                      onClick={() => removeOpcao(questaoIndex, opcaoIndex)}
                    >
                      <Icon name="close icon" />
                    </Button>
                  </OpcaoContainer>
                ))}
                <Button onClick={() => addOpcao(questaoIndex)}>
                  Adicionar Opção
                </Button>
              </>
            )}
          </QuestaoContainer>
        ))}

        <Button onClick={addQuestao}>Adicionar Questão</Button>

        <AnswerFileUpload
          onChangeFile={handleChangeAnswerFile}
        />

        <SaveContainer>
          <Button onClick={() => saveTeste(false)}>
            <Icon name="save" />
            Salvar Teste
          </Button>

          {idLicao && (
            <Button positive onClick={() => saveTeste(true)}>
              <Icon name="check" />
              Salvar e Adicionar a Lição
            </Button>
          )}
        </SaveContainer>
      </Content>
    </Container>
  );
};

export default CriarTeste;
